import * as React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Box, Button, Container, Paper, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { Auth, CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";

export const UnauthenticatedSubmissionsDisabledMessage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const signIn = useCallback(() => {
    Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Cognito });
  }, []);

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 10, borderRadius: 2 }}>
        <Typography variant="h5" component="h1" gutterBottom color="primary">
          {t("createProject.unsignedUser.unauthenticatedDisabled.title")}
        </Typography>

        <Typography variant="body1" paragraph>
          {t("createProject.unsignedUser.unauthenticatedDisabled.message")}
        </Typography>

        <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button variant="contained" color="primary" onClick={signIn}>
              {t("createProject.unsignedUser.unauthenticatedDisabled.signIn")}
            </Button>
            <Button variant="outlined" onClick={() => history.push("/")}>
              {t("createProject.unsignedUser.unauthenticatedDisabled.returnToHome")}
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};
